// ============================================
// VENUE ICON MAPPING CONFIGURATION
// Complete mapping for all venue types
// ============================================

// Import ALL your available icons
import barmapmarker from '../assets/MapmarkerIcons/beer128.png';
import beach128 from '../assets/MapmarkerIcons/beach128.png';
import bread128 from '../assets/MapmarkerIcons/Bread128.png';
import burger_fastfood128 from '../assets/MapmarkerIcons/burger_fastfood128.png';
import cocktailbar1024 from '../assets/MapmarkerIcons/cocktailbar1024.png';
import coffee_128 from '../assets/MapmarkerIcons/coffee_128.png';
import dessert128 from '../assets/MapmarkerIcons/dessert128.png';
import gym128 from '../assets/MapmarkerIcons/gym128.png';
import icecream from '../assets/MapmarkerIcons/icecream.svg';
import juice128 from '../assets/MapmarkerIcons/juice128.png';
import milk128 from '../assets/MapmarkerIcons/milk128.png';
import outdoor_seating from '../assets/MapmarkerIcons/outdoor_seating.png';
import pet_friendly from '../assets/MapmarkerIcons/pet_friendly.png';
import pharmacy128 from '../assets/MapmarkerIcons/pharmacy128.png';
import coworking128 from '../assets/MapmarkerIcons/laptop128.png';
import restaurant_with_wifi from '../assets/MapmarkerIcons/Restaurant_128.png';
import samosa128 from '../assets/MapmarkerIcons/samosa128.png';
import shisha128 from '../assets/MapmarkerIcons/shisha128.png';
import shopping_bag_128 from '../assets/MapmarkerIcons/shopping_bag_128.png';
import streetfood128 from '../assets/MapmarkerIcons/streetfood128.png';
import tea128 from '../assets/MapmarkerIcons/tea128.png';
import veg_eleaf_128 from '../assets/MapmarkerIcons/veg_eleaf_128.png';
import vegan_restaurant from '../assets/MapmarkerIcons/vegan_restaurant.png';
import whiskey_final from '../assets/MapmarkerIcons/whiskey_final.svg';
import wine128 from '../assets/MapmarkerIcons/wine128.png';
import wrap128 from '../assets/MapmarkerIcons/wrap128.png';
import popcorn128 from '../assets/MapmarkerIcons/popcorn128.png';
import yoga_128 from '../assets/MapmarkerIcons/yoga_128.png';  // ✅ ADD THIS
import pilates_128 from '../assets/MapmarkerIcons/pilates_128.png';  // ✅ ADD THIS
// ============================================
// EXACT VENUE TYPE MAPPING (from your screenshot)
// These are the 23 types visible in your UI
// ============================================
export const VENUE_TYPE_ICON_MAP = {
  // Row 1
  'Luqaimat Stall (Emirati Sweet Dumplings)': samosa128,
  'Kunafa Dessert Cart': dessert128,
  'Dates & Dry Fruits Vendor': samosa128,
  'Ice Cream Pushcart': icecream,
  'Arabic Coffee Pushcart': coffee_128,
  
  // Row 2
  'Sugarcane Juice Cart': juice128,
  'Henna Design Stall': shopping_bag_128,
  'Kuffi / Ice Lolly Cart': icecream,
  'Kebab / Tikka Grill Stall': streetfood128,
  'Falafel Cart': samosa128,
  
  // Row 3
  'Manakish / Fatayer Stall': bread128,
  'Shawarma Cart': wrap128,
  'Fresh Juice / Tender Coconut Cart': juice128,
  'Biryani / Rice Dish Cart': streetfood128, // ✅ CHANGED: Now uses streetfood128.png
  'Chaiwala / Karak Tea Cart': tea128,
  
  // Row 4
  'Shawarma Stand': wrap128,
  'Fresh Lemonade Cart': juice128,
  'Churros / Donuts Cart': dessert128,
  'Popcorn & Cot Candy Cart': popcorn128,
  
  // ✅ ADD MISSING VENUE TYPES
  'Tea House': tea128,
  'Coffee Shop': coffee_128,
  'Bakery Café': dessert128,
  'Dessert Shop': dessert128,
  'Ice Cream Parlour': icecream,
  'Sweet Shop (Mithai)': dessert128,
  'Halwai': dessert128, // ✅ CHANGED: Now uses dessert128.png
  'Cocktail Bar': cocktailbar1024,  
  'Wine Bar': wine128,
  'Shisha Lounge': shisha128,
  'Yoga Studio': yoga_128,
  'Pilates Studio': pilates_128,
  'CrossFit': gym128, // ✅ ADD: CrossFit uses gym128.png
  
  // Additional common types (not in screenshot but good to have)
  'Samosa / Pakora Stall': samosa128,
  'Camel Milk Vendor': milk128,
  'Mobile Food Truck': streetfood128,
  'Street Food Cart': streetfood128,
  'Food Stall': streetfood128,
  'Street Vendor': streetfood128,
  'Wrap / Shawarma Stand': wrap128,
  'Souvenir / Trinket Stall': shopping_bag_128,
};

// ============================================
// CATEGORY-BASED MAPPING
// ============================================
export const CATEGORY_ICON_MAP = {
  // Food & Beverage
  'Street Vendor': streetfood128,
  'Bar': barmapmarker,
  'Restaurant': restaurant_with_wifi,
  'Cafe': coffee_128,
  'Fast Food': burger_fastfood128,
  'Dessert': dessert128,
  'Fine Dining': restaurant_with_wifi,
  'Vegetarian-only Restaurant': restaurant_with_wifi,
  'Diner': restaurant_with_wifi, 
  'Barbecue House': restaurant_with_wifi, 
  'Seafood Restaurant': restaurant_with_wifi,
  
  // Beverages
  'Juice Bar': juice128,
  'Coffee Shop': coffee_128,
  'Tea Stall': tea128,
  'Cocktail Bar': cocktailbar1024,
  'Wine Bar': wine128,
  'Whiskey Bar': whiskey_final,
  'Brewpub': barmapmarker,
  'Pub': barmapmarker,
  'Shisha Lounge': shisha128,
  'Pool Bar': barmapmarker,
  
  // Hospitality
  'Beach Club': beach128,
  'Hotel': shopping_bag_128,
  
  // Work & Fitness
  'Coworking': coworking128,
  'Gym': gym128,
  'Fitness Center': gym128,
  'Yoga Studio': yoga_128,  // ✅ CHANGED TO YOGA ICON
  'Pilates Studio': pilates_128,  // ✅ CHANGED TO PILATES ICON
  'CrossFit': gym128, // ✅ ADD: CrossFit uses gym128.png
  
  // Wellness
  'Pharmacy': pharmacy128,
  'Spa': shopping_bag_128,
  'Salon': shopping_bag_128,
  
  // Special
  'Vegan Restaurant': veg_eleaf_128,
  'Vegetarian Restaurant': veg_eleaf_128,
};

// ============================================
// KEYWORD-BASED PATTERN MATCHING
// For flexible matching when exact match fails
// ============================================
export const KEYWORD_PATTERNS = [
  // Desserts & Sweets
  { keywords: ['luqaimat', 'dumpling'], icon: samosa128 },
  { keywords: ['kunafa', 'kunafeh'], icon: dessert128 },
  { keywords: ['ice cream', 'icecream', 'gelato', 'ice lolly', 'kuffi', 'pushcart'], icon: icecream },
  { keywords: ['dessert', 'sweet', 'cake', 'pastry'], icon: dessert128 },
  { keywords: ['churros', 'donuts', 'donut'], icon: dessert128 },
  { keywords: ['popcorn', 'candy', 'cotton candy'], icon: popcorn128 },
  { keywords: ['bread', 'manakish', 'fatayer'], icon: bread128 },
  
  // Beverages
  { keywords: ['juice', 'sugarcane', 'lemonade', 'coconut', 'tender coconut'], icon: juice128 },
  { keywords: ['coffee', 'arabic coffee', 'qahwa'], icon: coffee_128 },
  { keywords: ['tea', 'chai', 'karak', 'chaiwala'], icon: tea128 },
  { keywords: ['milk', 'camel milk'], icon: milk128 },
  
  // Savory Food
  { keywords: ['shawarma', 'wrap', 'falafel'], icon: wrap128 },
  { keywords: ['samosa', 'pakora', 'fritter'], icon: samosa128 },
  { keywords: ['kebab', 'tikka', 'grill', 'bbq'], icon: streetfood128 },
  { keywords: ['biryani', 'rice'], icon: streetfood128 }, // ✅ CHANGED: Now uses streetfood128.png
  { keywords: ['dates', 'dry fruit', 'nuts'], icon: samosa128 },
  
  // General Street Food
  { keywords: ['cart', 'stall', 'stand', 'pushcart', 'vendor'], icon: streetfood128 },
  { keywords: ['street food', 'food truck', 'mobile food'], icon: streetfood128 },
  
  // Services
  { keywords: ['henna', 'mehndi', 'design'], icon: shopping_bag_128 },
  { keywords: ['souvenir', 'trinket', 'gift'], icon: shopping_bag_128 },
  
  // Restaurants
  { keywords: ['fast food', 'burger', 'quick service'], icon: burger_fastfood128 },
  { keywords: ['restaurant', 'dining', 'eatery'], icon: restaurant_with_wifi },
  { keywords: ['vegan', 'vegetarian', 'plant-based', 'veg only'], icon: veg_eleaf_128 },
  
  // Bars & Nightlife
  { keywords: ['cocktail', 'mixology'], icon: cocktailbar1024 },
  { keywords: ['wine', 'vineyard', 'cellar'], icon: wine128 },
  { keywords: ['whiskey', 'whisky', 'bourbon'], icon: whiskey_final },
  { keywords: ['shisha', 'hookah', 'lounge'], icon: shisha128 },
  { keywords: ['bar', 'pub', 'tavern'], icon: barmapmarker },
  
  // Beach & Outdoor
  { keywords: ['beach', 'seaside', 'coastal'], icon: beach128 },
  { keywords: ['outdoor', 'terrace', 'patio'], icon: outdoor_seating },
  
  // Fitness & Wellness
  { keywords: ['gym', 'fitness', 'workout'], icon: gym128 },
  { keywords: ['crossfit', 'cross fit'], icon: gym128 }, // ✅ ADD: CrossFit keyword pattern
  { keywords: ['pharmacy', 'drugstore', 'medical'], icon: pharmacy128 },
  
  // Features
  { keywords: ['pet', 'pet-friendly', 'pets allowed'], icon: pet_friendly },
  { keywords: ['charging', 'power', 'socket', 'cowork'], icon: coworking128 },
  
  // Halwai keyword pattern
  { keywords: ['halwai', 'mithai', 'sweet shop'], icon: dessert128 }, // ✅ CHANGED: Now uses dessert128.png
];

// ============================================
// DEFAULT FALLBACK
// ============================================
export const DEFAULT_ICON = streetfood128;

// ============================================
// MAIN ICON RESOLVER (Enhanced)
// ============================================
export const getVenueIcon = (venue) => {
  if (!venue) return DEFAULT_ICON;
  
  // Extract and normalize venue information
  const venueType = (venue.venue_type_display || venue.venue_type || '').trim();
  const venueCategory = (venue.venue_category_display || venue.venue_category || '').trim();
  const accountName = (venue.name || '').toLowerCase().trim();
  
  // Priority 1: Exact venue type match (case-sensitive for exact names)
  if (VENUE_TYPE_ICON_MAP[venueType]) {
    return VENUE_TYPE_ICON_MAP[venueType];
  }
  
  // Priority 2: Exact category match (case-sensitive)
  if (CATEGORY_ICON_MAP[venueCategory]) {
    return CATEGORY_ICON_MAP[venueCategory];
  }
  
  // Priority 3: Case-insensitive venue type match
  const venueTypeLower = venueType.toLowerCase();
  for (const [key, icon] of Object.entries(VENUE_TYPE_ICON_MAP)) {
    if (key.toLowerCase() === venueTypeLower) {
      return icon;
    }
  }
  
  // Priority 4: Case-insensitive category match
  const venueCategoryLower = venueCategory.toLowerCase();
  for (const [key, icon] of Object.entries(CATEGORY_ICON_MAP)) {
    if (key.toLowerCase() === venueCategoryLower) {
      return icon;
    }
  }
  
  // Priority 5: Keyword patterns in venue type
  for (const pattern of KEYWORD_PATTERNS) {
    if (pattern.keywords.some(keyword => venueTypeLower.includes(keyword))) {
      return pattern.icon;
    }
  }
  
  // Priority 6: Keyword patterns in venue category
  for (const pattern of KEYWORD_PATTERNS) {
    if (pattern.keywords.some(keyword => venueCategoryLower.includes(keyword))) {
      return pattern.icon;
    }
  }
  
  // Priority 7: Keyword patterns in account name
  for (const pattern of KEYWORD_PATTERNS) {
    if (pattern.keywords.some(keyword => accountName.includes(keyword))) {
      return pattern.icon;
    }
  }
  
  // Priority 8: Feature-based attributes
  /* field removed - no Neon equivalent yet for Outdoor_seating, Charging_Ports, Veg_only, Pub_Wifi */
  
  // Final fallback
  return DEFAULT_ICON;
};

// ============================================
// HELPER: Get icon for category carousel
// ============================================
export const getCategoryIcon = (categoryName) => {
  if (!categoryName) return DEFAULT_ICON;
  
  const categoryTrimmed = categoryName.trim();
  
  // Exact match (case-sensitive)
  if (CATEGORY_ICON_MAP[categoryTrimmed]) {
    return CATEGORY_ICON_MAP[categoryTrimmed];
  }
  
  if (VENUE_TYPE_ICON_MAP[categoryTrimmed]) {
    return VENUE_TYPE_ICON_MAP[categoryTrimmed];
  }
  
  // Case-insensitive match
  const categoryLower = categoryTrimmed.toLowerCase();
  
  for (const [key, icon] of Object.entries(CATEGORY_ICON_MAP)) {
    if (key.toLowerCase() === categoryLower) {
      return icon;
    }
  }
  
  for (const [key, icon] of Object.entries(VENUE_TYPE_ICON_MAP)) {
    if (key.toLowerCase() === categoryLower) {
      return icon;
    }
  }
  
  // Keyword pattern match
  for (const pattern of KEYWORD_PATTERNS) {
    if (pattern.keywords.some(keyword => categoryLower.includes(keyword))) {
      return pattern.icon;
    }
  }
  
  return DEFAULT_ICON;
};

// ============================================
// EXPORT ALL
// ============================================
export default {
  getVenueIcon,
  getCategoryIcon,
  VENUE_TYPE_ICON_MAP,
  CATEGORY_ICON_MAP,
  KEYWORD_PATTERNS,
  DEFAULT_ICON
};
